import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import IconButton from "@mui/material/IconButton";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
function srcset(image, width, height, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${width * cols}&h=${height * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${width * cols}&h=${
      height * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}

export default function Eftekharat() {
  return (
    <>
      <TaskAltIcon />
      <strong>
        {" "}
        شرکت نگین آلومینیوم گلپایگان اولین واحد صادر کننده شمش آلیاژی آلومینیوم
        در ایران
      </strong>
      <ImageList
        sx={{
          //width: 350,
          height: 650,
          // Promote the list into its own layer in Chrome. This costs memory, but helps keeping high FPS.
          transform: "translateZ(0)",
        }}
        rowHeight={100}
        gap={1}
      >
        {itemData.map((item) => {
          const cols = item.featured ? 2 : 1;
          const rows = item.featured ? 2 : 1;

          return (
            <ImageListItem key={item.img} cols={cols} rows={rows}>
              <img
                {...srcset(item.img, 250, 200, rows, cols)}
                alt={item.title}
                loading="lazy"
              />
              <ImageListItemBar
                sx={{
                  background:
                    "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
                    "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
                  "& .muirtl-dasnyc-MuiImageListItemBar-title": {
                    fontSize: "0.65rem",
                  },
                }}
                title={item.title}
                position="bottom"
                actionIcon={
                  <IconButton
                    sx={{ color: "white" }}
                    aria-label={item.title}
                  ></IconButton>
                }
                actionPosition="left"
              />
            </ImageListItem>
          );
        })}
      </ImageList>
    </>
  );
}
const itemData = [
  {
    img: "https://negincompany.com/assets/app/ef01.JPG",
    title: "بازدید دکتر کرباسیان از محصولات شرکت نگین آلومینیوم",
    featured: true,
  },
  {
    img: "https://negincompany.com/assets/app/ef02.JPG",
    title: "بازدید دکتر مقیمی مدیرعامل ایران خودرو از شرکت نگین آلومینیوم",
    featured: true,
  },
  {
    img: "https://negincompany.com/assets/app/ef03.JPG",
    title: "بازدید وزیر سابق صنعت، معدن و تجارت از محصولات شرکت نگین آلومینیوم",
    featured: true,
  },
  {
    img: "https://negincompany.com/assets/app/ef04.JPG",
    title: "بازدید دکتر سلیمانی مدیرعامل شرکت سایپا از شرکت نگین آلومینیوم",
    featured: true,
  },
  {
    img: "https://negincompany.com/assets/app/ef05.JPG",
    title: "حضور در نمایشگاه‌های مختلف",
    featured: true,
  },
  {
    img: "https://negincompany.com/assets/app/ef06.JPG",
    title: "حمایت از تیم‌های ورزشی",
    featured: true,
  },
];
